import { updateOrganization } from '@dealstack/frontend/shared/dataExchange/services/organization.api';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationOrganization } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getUserFacingErrorMessage } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';

export const useUpdateOrganization = () => {
	const queryClient = useQueryClient();
	const tOrganization = useTranslationOrganization();

	return useMutation({
		mutationFn: updateOrganization,
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: [API_PATHS.ORGANIZATION_GET] });
			showToastV2({
				state: 'success',
				message: tOrganization('organizations_management.update.toast.success'),
			});
		},
		onError: (error) => {
			showToastV2({
				state: 'error',
				message:
					getUserFacingErrorMessage(error) ??
					tOrganization('organizations_management.update.toast.error'),
			});
		},
	});
};
